import {
	getcode,
	checkcode,
	businessmanAudit,
	getBusinessman,
	merchantregister,
	BusinessmanEdit,
	BusinessmanBlock,
	useDingding,
	getDatabaseList
} from '@/api/register'
// import { getToken } from '@/utils/auth'
const state = {}
const mutations = {}

const actions = {
	// 商户修改
	BusinessmanEdit ({}, data) {
		return new Promise((resolve, reject) => {
			BusinessmanEdit(data).then(res => {
				console.log(res, 'vuex,cheng')
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 商户拉黑
	BusinessmanBlock ({}, data) {
		return new Promise((resolve, reject) => {
			BusinessmanBlock(data).then(res => {
				console.log(res, 'vuex,cheng')
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 分页获取商家列表
	getBusinessman ({}, data) {
		return new Promise((resolve, reject) => {
			getBusinessman(data).then(res => {
				console.log(res, 'vuex,cheng')
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 获取验证码
	getcode ({}, data) {
		return new Promise((resolve, reject) => {
			getcode(data).then(res => {
				console.log(res, 'vuex,cheng')
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 验证 手机验证码
	checkcode ({}, data) {
		return new Promise((resolve, reject) => {
			checkcode(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 商家注册用户
	merchantregister ({}, data) {
		return new Promise((resolve, reject) => {
			merchantregister(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 商家审核
	businessmanAudit ({}, data) {
		return new Promise((resolve, reject) => {
			businessmanAudit(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 开启钉钉应用
	useDingding ({}, data) {
		return new Promise((resolve, reject) => {
			useDingding(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getDatabaseList ({}, data) {
		return new Promise((resolve, reject) => {
			getDatabaseList(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
